/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for WaveHookCtrl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class WaveHookCtrlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    hook(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    hook1(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook1(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook1(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook1(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    hook2(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook2(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook2(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook2(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    hook4(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook4(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook4(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook4(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    hook3(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook3(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook3(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook3(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    hook6(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook6(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook6(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook6(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    hook5(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    hook5(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    hook5(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    hook5(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/wvsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
